import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import UnpaidBookingList from '../../../components/Booking/UnpaidBookingList/UnpaidBookingList';
import s from './UnpaidBookings.css';

export class UnpaidBookings extends Component {
    render() {
        return (
            <div className={s.root}>
                <div className={s.container}>
                    <div className={cx(s.heading, 'textAlignRightRTL', 'textWhite')}>
                        Unpaid jobs
                    </div>
                    <div className={s.paddingRoutesSection}>
                        <UnpaidBookingList />
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(injectIntl, withStyles(s))(UnpaidBookings);
